import React, {useCallback, useRef} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getIsCheckInAtLeastTwoDaysAway} from 'modules/search/selectors'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

const filterKeys = ['payLater']

interface Props {
  isActive?: boolean
}

export const PayLaterPill: React.FC<Props> = ({isActive = false}) => {
  const {formatMessage} = useIntl()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const isCheckInAtLeastTwoDaysAway = useSelector(
    getIsCheckInAtLeastTwoDaysAway
  )

  const {submitFilters} = useFiltersForm(filterKeys)

  const handlePillClick = useCallback(() => {
    buttonRef.current?.blur()

    const updatedFilters = {
      payLater: (isActive ? undefined : '1') as BooleanUrlParam
    }

    submitFilters(updatedFilters)
  }, [isActive, submitFilters])

  if (!isCheckInAtLeastTwoDaysAway) return null

  return (
    <Pill
      ref={buttonRef}
      isSelected={isActive}
      dataId="payLaterFilter"
      onClick={handlePillClick}
      iconStart={<Icon name="CreditCard" />}
      iconEnd={isActive && <Icon name={'Close'} />}
    >
      {formatMessage(filterMessages.payLater)}
    </Pill>
  )
}
